import { render } from "./RiattivazioniPage.vue?vue&type=template&id=80f2f056&scoped=true"
import script from "./RiattivazioniPage.vue?vue&type=script&lang=js"
export * from "./RiattivazioniPage.vue?vue&type=script&lang=js"

import "./RiattivazioniPage.vue?vue&type=style&index=0&id=80f2f056&scoped=true&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80f2f056"]])

export default __exports__